import { type FC } from 'react';

import { Typography } from '@vakantiesnl/components/src/atoms/Typography';
import { useBreakpoints } from '@vakantiesnl/components/src/utils/useBreakpoints';

import { useStyles } from './AccommodationPlaceholder.styles';

type AccommodationPlaceholderProps = {
	title: string;
};

export const AccommodationPlaceholder: FC<AccommodationPlaceholderProps> = ({ title }) => {
	const { classes } = useStyles();
	const { isTabletOrIsDesktop } = useBreakpoints();

	return (
		<div className={classes.placeholderContainer}>
			<Typography variant={isTabletOrIsDesktop ? 'headingSm' : 'headingXs'} as="h3">
				{title}
			</Typography>
		</div>
	);
};
